const enlargeImage = () => {
  let scrollPosition = 0;

  $('.btn-enlarge').on('click', function () {
    var imageUrl = $(this).data('image');
    $('#lightbox-image').attr('src', imageUrl);
    $('#lightbox').css('display', 'flex').hide().fadeIn();

    scrollPosition = $(window).scrollTop();

    $('body').addClass('no-scroll').css({
      top: `-${scrollPosition}px`,
    });
  });

  $('.lightbox-close, #lightbox').on('click', function () {
    $('#lightbox').fadeOut(function () {
      $(this).css('display', 'none');

      $('body').removeClass('no-scroll').css({
        top: '',
      });
      $(window).scrollTop(scrollPosition);
    });
  });

  $('#lightbox-image').on('click', function (e) {
    e.stopPropagation();
  });
};

export default enlargeImage;
